<template>
  <tabs
    :options="{
      useUrlFragment: false,
    }"
    id="concept-tabs"
  >
    <tab name="Insumos">
      <md-table class="concepts-supply-table">
        <md-table-row>
          <md-table-head> Cantidad </md-table-head>
          <md-table-head> Código </md-table-head>
          <md-table-head colspan="4"> Insumo </md-table-head>
          <md-table-head> No utilizar </md-table-head>
        </md-table-row>

        <md-table-row
          v-for="(supply, index) in concept.supplies"
          :key="supply.id"
          :class="{
            'not-to-do-concept': !supply.expired_price,
            'text-gray': supply.dontUse,
          }"
        >
          <md-table-cell>
            {{ supply.quantity }}
          </md-table-cell>
          <md-table-cell>
            {{ supply.supplyData.code }}
          </md-table-cell>
          <md-table-cell colspan="4">
            {{ supply.supplyName }}
          </md-table-cell>

          <md-table-cell>
            <md-checkbox v-model="supply.dontUse" disabled />
          </md-table-cell>
        </md-table-row>
      </md-table>
    </tab>
    <!--
    <tab
      :key="file.codename"
      v-for="file in generationFileTypes"
      :name="file.name || file.codename"
      v-hide-in-production
    >
      <md-field>
        <label for="generator-file"> {{ file.name }}</label>
        <md-file
          id="generator-file"
          :key="file"
          v-for="file in files"
        >
        </md-file>
      </md-field>
    </tab>
    -->
  </tabs>
</template>

<script>

import purchaseService from '@/services/purchase'

const FILE_TYPES = [
  {
    codename: 'GO'
  },
  {
    codename: 'GOF'
  }
]

export default {

  name: 'ConceptDescription',

  props: {
    concept: {
      type: Object,
      default: () => ({})
    },
    fileTypes: {
      type: Array,
      required: true,
      default: () => []
    },
  },
  methods: {
    downloadWorkGenerator(qId, type) {
      purchaseService.getWorkGenerator(qId, type)
        .then(() => (this.$successMessage({ title:`Archivo descargado` })))
        .catch(this.$fireErrorResponse)
    },
  },

  data() {
    return {
      generationFileTypes: []
    }
  },

  watch: {
    fileTypes: {
      immediate: true,
      handler(value=[]) {
        this.generationFileTypes = FILE_TYPES
          .map(fType => [
            fType,
            value
              .find(({ codename }) =>
                fType.codename === codename)
          ]).map(([ ftype, fetched ]) => ({
            ...ftype,
            ...(fetched || {})
          }))
          
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.md-table-cell-container .md-button.unbounded-button {
  width: unset;
}
</style>



// WEBPACK FOOTER //
// src/pages/WorkPlan/WeeklyExecution/ConceptDescription.vue